import moment from 'moment'
Property.autoInjectAs = 'Property'

/* @ngInject */
export default function Property(DS) {
	var statuses = {
		active: 'status_active',
		archived: 'status_archived',
	}
	var statusLabels = {
		status_active: 'Active',
		status_archived: 'Archived',
	}

	return DS.defineResource({
		name: 'property',
		endpoint: 'properties',
		computed: {
			created_at_short: ['created_at', createdAtShort],
			status_readable: ['status', readableStatus],
		},
		meta: {
			statuses: statuses,
			statusLabels: statusLabels,
		},
		methods: {
			cloneFields: function () {
				return {
					id: this.id,
					client_id: this.client_id,
					name: this.name,
					status: this.status,
				}
			},
		},
		relations: {
			belongsTo: {
				client: [
					{
						localField: 'client',
						localKey: 'client_id',
					},
				],
			},
			hasMany: {
				project: {
					localField: 'projects',
					foreignKey: 'property_id',
				},
			},
		},
	})

	function createdAtDate(created_at) {
		return new Date(created_at)
	}

	function createdAtShort(created_at) {
		return moment(created_at).format('MM/DD/YYYY')
	}

	function readableStatus(status) {
		return statusLabels.hasOwnProperty(status) ? statusLabels[status] : ''
	}
}

/* @ngInject */
function runBlockProperty(Property) {}
